import { useState } from "react";

export const usePasswordToggle = () => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    }

    const inputType = isPasswordVisible ? 'text' : 'password';
    const icon = isPasswordVisible ? 'eye-open' : 'eye-closed';

    return {
        inputType,
        icon,
        togglePasswordVisibility
    };
}